module Meevo.Plugins.MeevoMessengerSettings {
    import IMeevoMessengerSettings = Meevo.Model.IMeevoMessengerSettings;

    export interface IMeevoMessengerUserCredentials {
        userName: string;
        token: string;
        classification: string;
    }

    export interface IMeevoMessengerSettingsService {
        initialSetup(classification: string): angular.IPromise<IMeevoMessengerSettings>;
        meevoMessengerLogin: (userCredentials: IMeevoMessengerUserCredentials) => angular.IPromise<any>;
        deleteAccount: () => angular.IPromise<any>;
        megoCustomApp: (config: string) => angular.IPromise<any>;
    }

    export class MeevoMessengerSettingsService implements IMeevoMessengerSettingsService {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.AppSettings',
        ];

        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings
        ) { }

        /**
         * Initial Meevo Messenger Setup
         * @param {string} classification
          * @returns {ng.IPromise<IMeevoMessengerSettings>} promise
         */
        initialSetup(classification: string): ng.IPromise<IMeevoMessengerSettings> {
            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.textel}/Setup`, 'POST', null)
                .then(response => response.data);
        }

        /**
         * Return promise
         * @param {IMeevoMessengerUserCredentials} userCredentials
         * @returns {ng.IPromise<any>} promise
         */
        meevoMessengerLogin(userCredentials: IMeevoMessengerUserCredentials): ng.IPromise<any> {
            let requestParams = {skipInterceptor: true};
            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.textel}/Login`, 'POST', userCredentials, requestParams )
        }

        deleteAccount(): ng.IPromise<any> {
            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.textel}/Settings/Remove`, 'POST',  { classification: 'TEXTEL'})
        }

        megoCustomApp(config: string): ng.IPromise<any> {
            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/MeevoMessenger/CustomApp`, 'POST', { classification: 'MEGO', configuration: config })
        }
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .service('meevo.plugins.meevoMessengerSettings.meevoMessengerSettingsService', MeevoMessengerSettingsService);
}
